var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hp-scormCon"},[_c(_vm.scormVersion,{tag:"component",attrs:{"res-id":_vm.resId,"update-id":_vm.updateId,"api-data":_vm.apiData},model:{value:(_vm.scormUrl),callback:function ($$v) {_vm.scormUrl=$$v},expression:"scormUrl"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }